import {UserUpdatePhoneNumberModal as UserUpdatePhoneNumberModalBase} from "@pg-mono/user";

import {UserUpdatePhoneNumberModalProvider} from "../providers/UserUpdatePhoneNumberModalProvider";

interface IProps {
    isOpen: boolean;
    onSuccess?: () => void;
}

export const UserUpdatePhoneNumberModal = (props: IProps) => {
    const {isOpen, onSuccess} = props;

    return (
        <UserUpdatePhoneNumberModalProvider>
            <UserUpdatePhoneNumberModalBase isOpen={isOpen} onSuccess={onSuccess} />
        </UserUpdatePhoneNumberModalProvider>
    );
};
import {UserUpdatePhoneNumberModal as UserUpdatePhoneNumberModalBase} from "@pg-mono/user";

import {UserUpdatePhoneNumberModalProvider} from "../providers/UserUpdatePhoneNumberModalProvider";

interface IProps {
    isOpen: boolean;
    onSuccess?: () => void;
}

export const UserUpdatePhoneNumberModal = (props: IProps) => {
    const {isOpen, onSuccess} = props;

    return (
        <UserUpdatePhoneNumberModalProvider>
            <UserUpdatePhoneNumberModalBase isOpen={isOpen} onSuccess={onSuccess} />
        </UserUpdatePhoneNumberModalProvider>
    );
};
